import { Stack, Typography } from '@mui/material';
import TestStatisticsDashboard from '../components/development/test-statistics.js';

export function DevelopmentView() {
  return (
    <Stack spacing={2}>
      <Typography variant="h5">Development Tools</Typography>
      <TestStatisticsDashboard />
    </Stack>
  );
}
